import { animatePulse } from "@/src/utils/animation.utils";
import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

/**
 * Placeholder shown while a preview is being extracted.
 *
 * Sized like the card that replaces it so the post does not jump when the
 * metadata lands. If extraction turns up nothing the skeleton simply goes away
 * and the post keeps its plain link.
 */
export const LinkPreviewSkeleton = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    const loop = animatePulse(opacity);
    return () => loop.stop();
  }, [opacity]);

  return (
    <Animated.View
      style={{ opacity }}
      testID="link-preview-skeleton"
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
    >
      <View className="mx-4 mb-2 border border-ash-3 rounded-xl overflow-hidden bg-chalk">
        <View style={{ width: "100%", aspectRatio: 1.91 }} className="bg-ash-3" />
        <View className="p-3 gap-2">
          <View className="h-3 w-3/4 rounded-md bg-ash-3" />
          <View className="h-3 w-full rounded-md bg-ash-3" />
          <View className="h-3 w-1/4 rounded-md bg-ash-3" />
        </View>
      </View>
    </Animated.View>
  );
};
